import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { LoginAction, type LoginActionResult } from '@/application/actions';
import type { LoginCommand } from '@/application/commands';
import { useAuth } from '@/presentation/contexts/AuthContext';

export const useLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const navigate = useNavigate();
  const { setUser, setToken } = useAuth();

  const login = async (command: LoginCommand): Promise<LoginActionResult> => {
    setIsLoading(true);
    setError(null);

    try {
      const loginAction = container.get<LoginAction>(TYPES.LoginAction);
      const result = await loginAction.execute(command);

      if (result.token && result.user) {
        setToken(result.token);
        setUser(result.user);
      }

      return result;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Login failed');
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { login, isLoading, error };
};
